'use strict';

export const recaptchaUpdater = type => {
  setInterval(function () {
    grecaptcha.ready(function () {
      grecaptcha.execute('6LezLUUlAAAAAIyUqZUrUthVjsb3-EZnLNX30fP0', { action: type }).then(function (token) {
        document.querySelector('[name="g-recaptcha-response"]').setAttribute('value', token);
      });
    });
  }, 100000);
};
